// extracted by mini-css-extract-plugin
export var collapse = "ProjectTeaser-module--collapse--+9rP8";
export var collapseContent = "ProjectTeaser-module--collapseContent--rT4do";
export var projectTeaser = "ProjectTeaser-module--projectTeaser--Iyaxs";
export var thumbnailContainer = "ProjectTeaser-module--thumbnailContainer--U2ktp";
export var infos = "ProjectTeaser-module--infos--rDzE9";
export var more = "ProjectTeaser-module--more--9Qg+w";
export var title = "ProjectTeaser-module--title--fBNqh";
export var textContainer = "ProjectTeaser-module--textContainer--5eqQR";